import { AxiosResponse, AxiosHeaders } from "axios";
import  axios from '../config/axios'
function headers(contentType: string = "application/json"): AxiosHeaders {
  const headerInstance = new AxiosHeaders();
  headerInstance.set("Content-Type", contentType);
  
  const token = localStorage.getItem("access_token");
  if (token) {
    headerInstance.set("Authorization", `Bearer ${token}`);
  }

  return headerInstance;
}


export async function service<T>(
  urlEndpoint: string,
  httpMethod: "post" | "get" | "put" | "delete",
  data: any = null,
  contentType: string = "application/json",
  id: string | number | null = null 
): Promise<AxiosResponse<T>> {
  try {
  
    if (httpMethod === "get" && id) {
      urlEndpoint = `${urlEndpoint}/${id}`;
    }
    if (httpMethod === "delete" && id) {
      urlEndpoint = `${urlEndpoint}/${id}/`;
    }
    

    const config = {
      headers: headers(contentType),
    };

    if (httpMethod === "post") {
      return await axios.post<T>(urlEndpoint, data, config);
    } else if (httpMethod === "get") {
      return await axios.get<T>(urlEndpoint, config);
    } else if (httpMethod === "put") {
      return await axios.put<T>(urlEndpoint, data, config);
    } else if (httpMethod === "delete") {
      return await axios.delete<T>(urlEndpoint, config);
    } else {
      throw new Error("Invalid HTTP method");
    }
  } catch (error: any) {
    console.error("Error in service call:", error.message);
    throw error;
  }
}
